export default __webpack_public_path__ + "static/blog-2-e59d5757f0ac8c1a2a20dbd6da917ba6.jpg";